var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-drawer',_vm._b({on:{"close":_vm.onDrawerClose}},'c-drawer',_vm.panelAttrs,false),[(_vm.contentVisible)?[_vm._t("default")]:_c('span',{staticClass:"c-drawer--empty"},[_vm._v(" "+_vm._s(_vm.noDataDefined)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }